import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import '@/assets/scss/config/creative/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
// import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import { InputText, Textarea, Select, Stepper, StepList,
    StepPanels, StepItem, Step, StepPanel, DataTable, Tooltip,
    Paginator, Skeleton, ToggleSwitch, Dialog, FloatLabel, Menu, Card
} from "primevue";
import "primeicons/primeicons.css";
import MakeupArtist from "@/theme/makeupartist";
import { Icon } from "@iconify/vue";
import {
    BBadge,
    BButton, BCard, BCardBody, BCardHeader, BCardTitle, BCol,
    BContainer, BOffcanvas,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BLink, BRow, BTab, BTabs,
    createBootstrap
} from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

window.mapFilterData = function mapFilters(data) {

    let filters = "?";

    for (const [key, value] of Object.entries(data)) {
        if (value !== undefined && value !== null && value !== '') {
            // Wrap fields in `filter[]` only if they are not pagination/meta fields
            if (['page', 'sort'].includes(key)) {
                filters += `${key}=${value}&`;
            } else {
                filters += `filter[${key}]=${value}&`;
            }
        }
    }

    return filters.slice(0, -1); // Remove the trailing '&'
};

createApp(App)
    .use(PrimeVue, {
        theme: {
            preset: MakeupArtist,
            options: {
                darkModeSelector: 'none',
            }
        },
    })
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(createBootstrap())
    .directive('tooltip', Tooltip)
    .component("DataTable", DataTable)
    .component("Paginator", Paginator)
    .component("InputText", InputText)
    .component("Textarea", Textarea)
    .component("Select", Select)
    .component("Stepper", Stepper)
    .component("StepList", StepList)
    .component("StepPanels", StepPanels)
    .component("StepItem", StepItem)
    .component("Step", Step)
    .component("StepPanel", StepPanel)
    .component("ToggleSwitch", ToggleSwitch)
    .component("Dialog", Dialog)
    .component("Menu", Menu)
    .component("Card", Card)
    .component("FloatLabel", FloatLabel)
    .component("Skeleton", Skeleton)
    .component("BContainer", BContainer)
    .component("BLink", BLink)
    .component("BDropdown", BDropdown)
    .component("BButton", BButton)
    .component("BRow", BRow)
    .component("BCard", BCard)
    .component("BCardHeader", BCardHeader)
    .component("BCardTitle", BCardTitle)
    .component("BCardBody", BCardBody)
    .component("BTabs", BTabs)
    .component("BTab", BTab)
    .component("BBadge", BBadge)
    .component("BCol", BCol)
    .component("BDropdownItem", BDropdownItem)
    .component("BDropdownDivider", BDropdownDivider)
    .component("BOffcanvas", BOffcanvas)
    .component("Icon", Icon)
    .use(ToastService)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(VueSweetalert2)
    .use(vClickOutside).mount('#app');

if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
}